import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill, secondaryOutline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M72.991 40.5983C72.991 40.5983 59.431 33.7083 55.381 28.9783C50.881 23.7183 51.081 1.07837 51.081 1.07837H38.661C38.661 1.07837 38.971 23.8283 34.361 28.9783C29.471 34.4383 16.751 40.3983 16.751 40.3983C22.941 54.9783 35.341 58.6984 44.871 58.6984C54.411 58.6984 66.801 55.1783 72.991 40.5983Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M86.5208 57.4983C84.9008 45.4983 81.3108 42.2483 76.6408 39.8983C74.1308 38.6283 59.5508 31.0583 59.5508 31.0583L54.2008 25.0383L44.8708 37.9083L35.5408 25.0383L30.1908 31.0583C30.1908 31.0583 15.6108 38.6283 13.1008 39.8983C8.4308 42.2483 4.99079 45.8983 3.22079 57.4983C1.40079 69.4383 1.30078 71.2683 1.30078 71.2683H88.4508C88.4408 71.2683 88.1508 69.5583 86.5208 57.4983Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M30.1904 31.0583L36.9104 43.9684L41.5704 33.6984"
        stroke={secondaryOutline}
        strokeMiterlimit="10"
        fill={secondaryFill}
      />
      <path
        d="M59.5511 31.0583L52.8311 43.9684L48.1611 33.6984"
        stroke={secondaryOutline}
        strokeMiterlimit="10"
        fill={secondaryFill}
      />
      <path
        d="M44.8806 44.1183C45.6096 44.1183 46.2005 43.5274 46.2005 42.7983C46.2005 42.0693 45.6096 41.4783 44.8806 41.4783C44.1515 41.4783 43.5605 42.0693 43.5605 42.7983C43.5605 43.5274 44.1515 44.1183 44.8806 44.1183Z"
        fill={secondaryOutline}
      />
      <path
        d="M44.8806 56.9983C45.6096 56.9983 46.2005 56.4074 46.2005 55.6783C46.2005 54.9493 45.6096 54.3583 44.8806 54.3583C44.1515 54.3583 43.5605 54.9493 43.5605 55.6783C43.5605 56.4074 44.1515 56.9983 44.8806 56.9983Z"
        fill={secondaryOutline}
      />
      <path
        d="M44.8806 69.1483C45.6096 69.1483 46.2005 68.5574 46.2005 67.8284C46.2005 67.0994 45.6096 66.5083 44.8806 66.5083C44.1515 66.5083 43.5605 67.0994 43.5605 67.8284C43.5605 68.5574 44.1515 69.1483 44.8806 69.1483Z"
        fill={secondaryOutline}
      />
      <path
        d="M28.1805 31.4083C28.1805 31.4083 28.7006 43.1284 39.1606 48.8284L39.8206 71.2883H1.31055C1.31055 71.2883 1.99053 65.1583 2.67053 60.2283C3.53053 53.9183 4.68054 47.9083 7.62054 44.3783C10.9205 40.4183 15.8605 37.6083 20.2505 35.3783C25.7806 32.5583 28.1805 31.4083 28.1805 31.4083Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M24.0801 34.1083C24.0801 34.1083 25.0701 48.5283 39.1101 53.5983"
        stroke={outline}
        fill="none"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M61.5609 31.4083C61.5609 31.4083 61.0409 43.1284 50.5809 48.8284L49.9209 71.2883H88.4309C88.4309 71.2883 87.7509 65.1583 87.0709 60.2283C86.2109 53.9183 85.0609 47.9083 82.1209 44.3783C78.8209 40.4183 73.8809 37.6083 69.4909 35.3783C63.9509 32.5583 61.5609 31.4083 61.5609 31.4083Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M65.6609 34.1083C65.6609 34.1083 64.6709 48.5283 50.6309 53.5983"
        stroke={outline}
        fill="none"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M53.1306 51.5183C53.6994 51.5183 54.1606 51.0571 54.1606 50.4883C54.1606 49.9194 53.6994 49.4584 53.1306 49.4584C52.5617 49.4584 52.1006 49.9194 52.1006 50.4883C52.1006 51.0571 52.5617 51.5183 53.1306 51.5183Z"
        fill="white"
      />
      <path
        d="M52.5505 68.2483C53.1194 68.2483 53.5805 67.7872 53.5805 67.2184C53.5805 66.6495 53.1194 66.1884 52.5505 66.1884C51.9817 66.1884 51.5205 66.6495 51.5205 67.2184C51.5205 67.7872 51.9817 68.2483 52.5505 68.2483Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="44.8687"
          y1="40.0111"
          x2="44.8687"
          y2="6.98367"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
